import { render, staticRenderFns } from "./service-private-data.vue?vue&type=template&id=1224b572&"
import script from "./service-private-data.vue?vue&type=script&lang=js&"
export * from "./service-private-data.vue?vue&type=script&lang=js&"
import style0 from "./service-private-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports